import { Injectable } from "@angular/core";
import { CoreService } from "../../base/core";
import { ServiceRoute } from "../../base/service-route";
import { CommonHttpOption } from "../../base/common-http-option";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class SubsidiaryCompanyService {
  constructor(private coreService: CoreService) {}
 // get customer
  getCustomerList(params: any, pageIndex: number = 1, pageSize: number = 10): Observable<any> {
    debugger
    return this.coreService.get(
      ServiceRoute.subsidiary.company.getCustomerList,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(pageIndex, pageSize)  
      .append('Id', params && params.Id ? params.Id : '')
      .append('NationalID', params && params.NationalID ? params.NationalID : '')
      .append('RegistrationID', params && params.RegistrationID ? params.RegistrationID : '')
      .append('EconomicCode', params && params.EconomicCode ? params.EconomicCode : '')
      .append('IsActive', params && params.IsActive ? params.IsActive : '')
      .append('CustomerName', params && params.CustomerName ? params.CustomerName : '')
      .append('ManagementName', params && params.ManagementName ? params.ManagementName : '')
  );
  }
 // get getCustomerListCombo
  getCustomerListCombo(): Observable<any> {
    return this.coreService.get(
      ServiceRoute.subsidiary.company.getCustomerListCombo,
      new CommonHttpOption().headers
  );
  }
    // add customer 
    addCustomer(command: any): Observable<any> {
      return this.coreService.post(
        ServiceRoute.subsidiary.company.customerAdd,
        command,
        new CommonHttpOption().headers
      );
    }
    // edit customer 
    customerEdit(command: any): Observable<any> {
    return this.coreService.put(
      ServiceRoute.subsidiary.company.customerEdit,
      command,
      new CommonHttpOption().headers
    );
  }
    // customerActiveDeactive 
    customerActiveDeactive(command: any): Observable<any> {
    return this.coreService.put(
      ServiceRoute.subsidiary.company.customerActiveDeactive,
      command,
      new CommonHttpOption().headers
    );
  }



}
